import { render, staticRenderFns } from "./PurchasedProducts.vue?vue&type=template&id=95eef920&scoped=true"
import script from "./PurchasedProducts.vue?vue&type=script&lang=js"
export * from "./PurchasedProducts.vue?vue&type=script&lang=js"
import style0 from "./PurchasedProducts.vue?vue&type=style&index=0&id=95eef920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eef920",
  null
  
)

export default component.exports